export default __webpack_public_path__ + "static/media/PalLogoUmmi.1ee9966f.png";